import { Button } from 'tedooo-web-design-system/ui';
import { Edit, Share } from 'tedooo-web-design-system/icons';
import { FC } from 'react';

import { translations } from 'translations/en';

interface IShopOwnerButtons {
  onShareClick(): void;
  onEditItemClick(): void;
}

const ShopOwnerButtons: FC<IShopOwnerButtons> = ({ onEditItemClick, onShareClick }) => {
  return (
    <div className="shop-owner-buttons-container">
      <Button
        type="secondary"
        size="medium"
        borderRadius="small"
        prefixIcon={<Share />}
        onClick={onShareClick}
        isFullWidth
        text={translations.COMMON.SHARE_ITEM}
      />
      <Button
        type="secondary"
        size="medium"
        borderRadius="small"
        prefixIcon={<Edit />}
        text={translations.COMMON.EDIT}
        isFullWidth
        onClick={onEditItemClick}
      />
    </div>
  );
};

export default ShopOwnerButtons;
